import { render, staticRenderFns } from "./MatIcon.vue?vue&type=template&id=f8964d82&functional=true&"
import script from "./MatIcon.vue?vue&type=script&lang=js&"
export * from "./MatIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports